/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import DashboardShell from "../../dashboard/DashboardShell";
import { useCountryContext } from "../../../context/CountryContext";
import { getSingleCountryDashboard } from "../../../lib/sysNavigation/SysNavigation";

const CountryDashboardComponent = () => {
  const { country_id } = useParams();
  const { countryStats, fetchCountryStats } = useCountryContext();

  useEffect(() => {
    if (!countryStats) fetchCountryStats(country_id);
  }, [country_id, countryStats]);

  const countryName = getSingleCountryDashboard() || "Country";

  return (
    <DashboardShell
      title={countryName}
      subtitle="Country · content footprint"
      stats={countryStats}
      clickRoute="/countries"
      showTableStats={false}
      hideGeography
      breadCrumbDefault={false}
    />
  );
};

export default CountryDashboardComponent;
